<template>
  <section class="main">
    <component
      :is="item.moduleCode"
      v-for="(item, index) in comData"
      :key="item.moduleCode + index"
      :indexData="indexData"
      :menuList="menuList"
    />
  </section>
</template>
<script>
import { Banner, Tool, NewList, Recommend, Shop } from "./index";
export default {
  name: "moduleCom",
  mounted() {
    console.log(this.homeData);
  },
  props: {
    comData: {
      type: Array,
      default: () => [],
    },
    indexData: {
      type: Object,
    },
    menuList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      componentType: "menus", // 这里是你的数据字段，根据不同的数据值来决定渲染哪个组件
    };
  },
  computed: {
    componentName() {
      switch (this.componentType) {
        case "banner":
          return "Banner";
        case "tool":
          return "Tool";
        case "newList":
          return "NewList";
        case "recommend":
          return "Recommend";
        case "shop":
          return "Shop";
        default:
          return "banner";
      }
    },
  },
  components: {
    Banner, Tool, NewList, Recommend, Shop
  },
};
</script>

<style lang="scss">
@import "./index.scss";
.van-count-down,
.count_down {
  display: flex;
  align-items: center;
  justify-content: center;
  .colon {
    display: inline-block;
    margin: 0 0.05rem;
    color: var(--bg2);
  }
  .block {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 0.35rem;
    height: 0.35rem;
    color: #000;
    font-size: 0.22rem;
    font-weight: 400;
    text-align: center;
    background: linear-gradient(#ffa06a, #f8cc85);
    border-radius: 0.05rem;
  }
}
</style>
